export default __webpack_public_path__ + "static/media/rafa6.4c04d1c0.jpg";